import { render, staticRenderFns } from "./Slider.vue?vue&type=template&id=68077684&scoped=true&"
import script from "./Slider.vue?vue&type=script&lang=js&"
export * from "./Slider.vue?vue&type=script&lang=js&"
import style0 from "./Slider.vue?vue&type=style&index=0&id=68077684&prod&lang=scss&"
import style1 from "./Slider.vue?vue&type=style&index=1&id=68077684&prod&lang=scss&"
import style2 from "./Slider.vue?vue&type=style&index=2&id=68077684&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68077684",
  null
  
)

export default component.exports